// extracted by css-extract-rspack-plugin
export default {"key":"KrXO7xbcvfIP7IvH","value":"HfPqkxzwJ1UhKl7Q"};